import { IPageLink, INavSubRoute, PAGE_LINK_TYPES } from './page-link.interface';

export class PageLink implements IPageLink {
  uid: number;
  route: string;
  name: string;
  originalName: string;
  icon: string;
  color: string;
  disabled: boolean;
  active: boolean;
  divider: boolean;
  type: PAGE_LINK_TYPES;
  backgroundColor: string;
  visible: boolean;
  clickable: boolean;
  skuCode: string;
  iconKey: string;
  group: number;
  children: INavSubRoute[];
  expanded: boolean;
  intercomTarget: string | null;

  constructor(data: IPageLink) {
    this.uid   = data.uid;
    this.route = data.route;
    this.name  = data.name;
    this.originalName = data.originalName;
    this.icon  = data.icon;
    this.color = data.color;
    this.disabled = data.disabled;
    this.active = data.active;
    this.divider = Boolean(data.divider);
    this.type  = data.type;
    this.backgroundColor = data.backgroundColor;
    this.visible = data.visible;
    this.clickable = data.clickable;
    this.skuCode = data.skuCode;
    this.iconKey = data.iconKey || '';
    this.group = data.group || 0;
    this.children = data.children || [];
    this.expanded = Boolean(data.expanded);
    this.intercomTarget = data.intercomTarget ?? null;
  }

  set activation(val: boolean) {
    this.active = val;
  }

  get activation(): boolean {
    return this.active;
  }

  set disable(val: boolean) {
    this.disabled = val;
  }

  get disable(): boolean {
    return this.disabled;
  }
}
